import api from '@/plugins/axios';
import { mountUrl } from './helper';

const BASE_PATH = 'plan_signature';

export default {
  async create(body) {
    const url = mountUrl(`/${BASE_PATH}`);
    return api.post(url, body);
  },
  async search(queryParams) {
    const url = mountUrl(`/${BASE_PATH}`, queryParams);
    return api.get(url);
  }
};
